import { render, staticRenderFns } from "./NoDistrict.vue?vue&type=template&id=821b82b8"
import script from "./NoDistrict.vue?vue&type=script&lang=js"
export * from "./NoDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports